<app-card [type]="3" [title]="'Create new account' | translate">
  <h3 cardText3 class="text-center">{{ 'feature.account.sign_up' | translate }}</h3>
  <div cardBody3>
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" vgFocusFirstInvalid [form]="registerForm">
      <div class="form-group">
        <label for="username"><i class="bi bi-person-plus"></i> {{ 'feature.account.username' | translate }}</label>
        <input
          id="username"
          type="text"
          [placeholder]="'common.placeholder.username' | translate"
          formControlName="username"
          class="form-control"
        />
        <vg-error-section
          [label]="'common.placeholder.username' | translate"
          [group]="registerForm"
          controlName="username"
        ></vg-error-section>
      </div>
      <div class="form-group">
        <label for="password"><i class="bi bi-key"></i> {{ 'common.label.birthDate' | translate }}</label>
        <input
          id="password"
          type="password"
          [placeholder]="'common.placeholder.password' | translate"
          formControlName="password"
          class="form-control"
        />
        <vg-error-section
          [label]="'common.placeholder.password' | translate"
          [group]="registerForm"
          controlName="password"
        ></vg-error-section>
      </div>
      <div class="form-group">
        <label for="firstName"><i class="bi bi-tag"></i> {{ 'common.label.birthDate' | translate }}</label>
        <input
          id="firstName"
          type="text"
          [placeholder]="'common.placeholder.firstName' | translate"
          formControlName="firstName"
          class="form-control"
        />
        <vg-error-section
          [label]="'common.placeholder.firstName' | translate"
          [group]="registerForm"
          controlName="firstName"
        ></vg-error-section>
      </div>
      <div class="form-group">
        <label for="lastName"><i class="bi bi-tag"></i> {{ 'common.label.birthDate' | translate }}</label>
        <input
          id="lastName"
          type="text"
          [placeholder]="'common.placeholder.lastName' | translate"
          formControlName="lastName"
          class="form-control"
        />
        <vg-error-section
          [label]="'common.placeholder.lastName' | translate"
          [group]="registerForm"
          controlName="lastName"
        ></vg-error-section>
      </div>
      <label><i class="bi bi-gender-ambiguous"></i> {{ 'common.label.birthDate' | translate }}</label>
      <div class="form-group">
        <div class="form-check form-check-inline">
          <input type="radio" id="male" [value]="1" formControlName="gender" />
          <label class="form-check-label ml-2" for="male"
            ><i class="bi bi-gender-male"></i> {{'common.radio.gender.male' | translate}}</label
          >
        </div>
        <div class="form-check form-check-inline">
          <input type="radio" id="female" [value]="2" formControlName="gender" />
          <label class="form-check-label ml-2" for="female"
            ><i class="bi bi-gender-female"></i> {{'common.radio.gender.female' | translate}}</label
          >
        </div>
        <div class="form-check form-check-inline">
          <input type="radio" id="bisexual" [value]="3" formControlName="gender" />
          <label class="form-check-label ml-2" for="male"
            ><i class="bi bi-gender-male"></i> {{'common.radio.gender.bisexual' | translate}}</label
          >
        </div>
        <div class="form-check form-check-inline">
          <input type="radio" id="unknown" [value]="4" formControlName="gender" />
          <label class="form-check-label ml-2" for="female"
            ><i class="bi bi-gender-female"></i> {{'common.radio.gender.unknown' | translate}}</label
          >
        </div>
      </div>
      <div class="form-group">
        <label for="birthDate"><i class="bi bi-calendar3"></i> {{ 'common.label.birthDate' | translate }}</label>
        <input id="birthDate" type="date" formControlName="birthDate" class="form-control" />
        <vg-error-section [label]="'common.label.birthDate' | translate" [group]="registerForm" controlName="birthDate"></vg-error-section>
      </div>
      <div class="form-group">
        <label for="phoneNumber"><i class="bi bi-telephone"></i> {{ 'common.label.phoneNumber' | translate }}</label>
        <input
          id="phoneNumber"
          type="text"
          [placeholder]="'common.placeholder.phoneNumber' | translate"
          formControlName="phoneNumber"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label for="email"><i class="bi bi-envelope"></i> {{ 'common.label.email' | translate }}</label>
        <input id="email" type="text" [placeholder]="'common.placeholder.email' | translate" formControlName="email" class="form-control" />
        <vg-error-section [label]="'common.label.email' | translate" [group]="registerForm" controlName="email"></vg-error-section>
      </div>
      <button [disabled]="loading" class="btn btn-primary rounded-pill float-right mt-2">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        <span>{{ 'feature.account.sign_up' | translate }}</span>
      </button>
    </form>
  </div>
</app-card>
